// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3pisu","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__P-oI8"};